import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import TourCard from './TourCard';
import TourCardTwo from './TourCardTwo';
import { fetchTours } from '../../services/api';

function TourInner() {
    const [activeTab, setActiveTab] = useState('tab-grid');
    const [currentPage, setCurrentPage] = useState(1);
    const [tours, setTours] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCountry, setSelectedCountry] = useState('');
    const [countries, setCountries] = useState([]);
    const [latestTours, setLatestTours] = useState([]);
    const [pagination, setPagination] = useState({
        meta: {},
        links: {}
    });

    // Load all tours to extract countries (fetch first 100 pages or use a separate endpoint)
    useEffect(() => {
        loadAllToursForCountries();
        loadLatestTours();
    }, []);

    const loadLatestTours = async () => {
        try {
            const response = await fetchTours(1, '', '');
            // Get the first 3 tours as latest
            setLatestTours(response.tours.slice(0, 3));
        } catch (err) {
            console.error('Error loading latest tours:', err);
        }
    };

    useEffect(() => {
        loadTours(currentPage, searchQuery, selectedCountry);
    }, [currentPage, searchQuery, selectedCountry]);

    const loadAllToursForCountries = async () => {
        try {
            // Fetch first page to get total pages
            const firstResponse = await fetchTours(1, '', '');
            const totalPages = firstResponse.pagination.meta.last_page || 1;
            let allTours = [...firstResponse.tours];
            
            // Fetch remaining pages if there are more
            if (totalPages > 1) {
                const remainingPromises = [];
                for (let page = 2; page <= totalPages; page++) {
                    remainingPromises.push(fetchTours(page, '', ''));
                }
                
                const remainingResponses = await Promise.all(remainingPromises);
                remainingResponses.forEach(response => {
                    allTours = [...allTours, ...response.tours];
                });
            }
            
            // Extract unique countries and count tours per country
            const countryMap = new Map();
            
            allTours.forEach(tour => {
                if (tour.country && tour.country.name) {
                    const countryName = tour.country.name;
                    countryMap.set(countryName, (countryMap.get(countryName) || 0) + 1);
                }
            });
            
            // Convert to array and sort by name
            const countriesArray = Array.from(countryMap.entries())
                .map(([name, count]) => ({ name, count }))
                .sort((a, b) => a.name.localeCompare(b.name));
            
            setCountries(countriesArray);
        } catch (err) {
            console.error('Error loading countries:', err);
        }
    };

    const loadTours = async (page, search = '', country = '') => {
        try {
            setLoading(true);
            setError(null);
            const response = await fetchTours(page, search, country);
            setTours(response.tours);
            setPagination(response.pagination);
        } catch (err) {
            setError(err.message || 'Failed to load tours. Please try again later.');
            console.error('Error loading tours:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const searchValue = formData.get('search') || '';
        setSearchQuery(searchValue);
        setCurrentPage(1); // Reset to first page on new search
    };

    const handleCountryClick = (countryName) => {
        if (!countryName || selectedCountry === countryName) {
            // If empty string or same country clicked, clear filter
            setSelectedCountry('');
        } else {
            setSelectedCountry(countryName);
        }
        setCurrentPage(1); // Reset to first page on country filter
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= (pagination.meta.last_page || 1)) {
            setCurrentPage(page);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Decode HTML entities helper function
    const decodeHtml = (html) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };
    return (
        <section className="space">
            <div className="container shape-mockup-wrap">
                <div className="th-sort-bar">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-4">
                            <div className="search-form-area">
                                <form className="search-form" onSubmit={handleSearch}>
                                    <input 
                                        type="text" 
                                        name="search"
                                        placeholder="Search" 
                                        defaultValue={searchQuery}
                                    />
                                    <button type="submit">
                                        <i className="fa-light fa-magnifying-glass" />
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <div className="sorting-filter-wrap">
                                <div className="nav" role="tablist">
                                    <Link
                                        to="#"
                                        id="tab-destination-grid"
                                        data-bs-toggle="tab"
                                        data-bs-target="#tab-grid"
                                        role="tab"
                                        aria-controls="tab-grid"
                                        aria-selected="true"
                                        className={`${activeTab === 'tab-grid' ? 'active' : ''}`}
                                        type="button"
                                        onClick={() => setActiveTab('tab-grid')}
                                    >
                                        <i className="fa-light fa-grid-2" />
                                    </Link>
                                    <Link
                                        to="#"
                                        id="tab-destination-list"
                                        data-bs-toggle="tab"
                                        data-bs-target="#tab-list"
                                        role="tab"
                                        aria-controls="tab-list"
                                        aria-selected="false"
                                        className={`${activeTab === 'tab-list' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('tab-list')}
                                    >
                                        <i className="fa-solid fa-list" />
                                    </Link>
                                </div>
                                <form className="woocommerce-ordering" method="get">
                                    <select
                                        name="orderby"
                                        className="orderby"
                                        aria-label="destination order"
                                    >
                                        <option value="menu_order" >
                                            Default Sorting
                                        </option>
                                        <option value="popularity">Sort by popularity</option>
                                        <option value="rating">Sort by average rating</option>
                                        <option value="date">Sort by latest</option>
                                        <option value="price">Sort by price: low to high</option>
                                        <option value="price-desc">Sort by price: high to low</option>
                                    </select>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        {loading && (
                            <div className="text-center py-5">
                                <p>Loading tours...</p>
                            </div>
                        )}
                        
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                <strong>Error:</strong> {error}
                            </div>
                        )}
                        
                        {!loading && !error && (
                            <div className="tab-content" id="nav-tabContent">
                                <div
                                    className={`tab-pane fade ${activeTab === 'tab-grid' ? 'show active' : ''}`} id="tab-grid" role="tabpanel">
                                    {tours.length === 0 ? (
                                        <div className="text-center py-5">
                                            <p>No tours found.</p>
                                        </div>
                                    ) : (
                                        <div className="row gy-24 gx-24">
                                            {tours.map((data) => (
                                                <div key={data.id} className="col-md-6">
                                                    <TourCard
                                                        tour={data}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div
                                    className={`tab-pane fade ${activeTab === 'tab-list' ? 'show active' : ''}`} id="tab-list" role="tabpanel">
                                    {tours.length === 0 ? (
                                        <div className="text-center py-5">
                                            <p>No tours found.</p>
                                        </div>
                                    ) : (
                                        <div className="row gy-30">
                                            {tours.map((data) => (
                                                <div key={data.id} className="col-12">
                                                    <TourCardTwo
                                                        tour={data}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        
                        {!loading && !error && pagination.meta.last_page > 1 && (
                            <div className="th-pagination text-center mt-60">
                                <ul>
                                    {pagination.meta.links && pagination.meta.links.map((link, index) => {
                                        if (link.url === null || link.page === null) {
                                            return null;
                                        }
                                        
                                        const pageNumber = link.page;
                                        const isActive = link.active;
                                        const isPrevious = link.label.includes('Previous');
                                        const isNext = link.label.includes('Next');
                                        
                                        let displayLabel = decodeHtml(link.label);
                                        if (isNext) {
                                            displayLabel = displayLabel.replace('»', '').trim();
                                        } else if (isPrevious) {
                                            displayLabel = displayLabel.replace('«', '').trim();
                                        }
                                        
                                        return (
                                            <li key={index}>
                                                <Link
                                                    className={`${isActive ? 'active' : ''} ${isNext ? 'next-page' : ''}`}
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (pageNumber) {
                                                            handlePageChange(pageNumber);
                                                        }
                                                    }}
                                                >
                                                    {isNext && (
                                                        <>
                                                            {displayLabel} <img src="/assets/img/icon/arrow-right4.svg" alt="" />
                                                        </>
                                                    )}
                                                    {!isNext && displayLabel}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <aside className="sidebar-area">
                            <div className="widget widget_categories  ">
                                <h3 className="widget_title">Countries</h3>
                                <ul>
                                    {selectedCountry && (
                                        <li>
                                            <Link 
                                                to="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleCountryClick('');
                                                }}
                                                style={{ 
                                                    cursor: 'pointer',
                                                    color: '#007bff',
                                                    textDecoration: 'underline'
                                                }}
                                            >
                                                <img src="/assets/img/theme-img/map.svg" alt="" />
                                                Show All
                                            </Link>
                                        </li>
                                    )}
                                    {countries.length === 0 ? (
                                        <li>
                                            <span>Loading countries...</span>
                                        </li>
                                    ) : (
                                        countries.map((country, index) => (
                                            <li key={index}>
                                                <Link 
                                                    to="#" 
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleCountryClick(country.name);
                                                    }}
                                                    className={selectedCountry === country.name ? 'active' : ''}
                                                    style={{ 
                                                        cursor: 'pointer',
                                                        fontWeight: selectedCountry === country.name ? 'bold' : 'normal',
                                                        color: selectedCountry === country.name ? '#007bff' : 'inherit'
                                                    }}
                                                >
                                                    <img src="/assets/img/theme-img/map.svg" alt="" />
                                                    {country.name}
                                                </Link>
                                                <span>({country.count})</span>
                                            </li>
                                        ))
                                    )}
                                </ul>
                            </div>
                            <div className="widget">
                                <h3 className="widget_title">Latest Tours</h3>
                                <div className="recent-post-wrap">
                                    {latestTours.length === 0 ? (
                                        <p className="text-muted">Loading tours...</p>
                                    ) : (
                                        latestTours.map((tour) => (
                                            <div className="recent-post" key={tour.id}>
                                                <div className="media-img">
                                                    <Link to={`/tours/${tour.slug}`}>
                                                        <img
                                                            src={tour.thumbnail_image || '/assets/img/blog/recent-post-1-1.jpg'}
                                                            alt={tour.title}
                                                        />
                                                    </Link>
                                                </div>
                                                <div className="media-body">
                                                    <h4 className="post-title">
                                                        <Link className="text-inherit" to={`/tours/${tour.slug}`}>
                                                            {tour.title}
                                                        </Link>
                                                    </h4>
                                                    <div className="recent-post-meta">
                                                        <span>
                                                            <i className="fa-light fa-clock" />
                                                            {tour.duration ? `${tour.duration} Days` : 'N/A'}
                                                        </span>
                                                        {tour.price && (
                                                            <span style={{ marginLeft: '10px' }}>
                                                                <i className="fa-light fa-dollar-sign" />
                                                                {tour.price}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
                <div
                    className="shape-mockup shape1 d-none d-xxl-block"
                    style={{ bottom: "7%", right: "-8%" }}
                >
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape2 d-none d-xl-block"
                    style={{ bottom: "1%", right: "-7%" }}
                >
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape3 d-none d-xxl-block"
                    style={{ bottom: "-2%", right: "-12%" }}
                >
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
            </div>
        </section>

    )
}

export default TourInner
